import Module from '../../module';
import scroll from '../../../libs/scroll/scroll';

interface OptionsInterface {
	cssId: {
		anim?: {
			aboutAboutHeliumAerospaceContentSectionHeaderCls: string;
			aboutAboutHeliumAerospaceContentSectionTextInnerCls: string;
		}
	},

	slug: string
}

class Aerospace extends Module {

	publicVars: OptionsInterface;

	constructor(options: OptionsInterface) {
		super('About About Helium Aerospace Module');

		this.publicVars = options;
	}

	startup() {
		this.msg('startup');

		scroll.init();
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.aboutAboutHeliumAerospaceContentSectionHeaderCls || '','about_about_helium_aerospace', { animCls: 'animate__fadeInLeft25P', once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.aboutAboutHeliumAerospaceContentSectionTextInnerCls || '','about_about_helium_aerospace', { animCls: 'animate__fadeInRight25P', once: true});
	}

	bind() {
		this.msg('bind');
	}
}

export default Aerospace;